/**
 * 지연 동작 유틸리티
 *
 * 자동 완성 UI와 같이 입력이 계속 발생하는 경우
 * 그때마다 Ajax 요청을 하는 것은 비효율적이고 입력한 것과 맞지 않을 수 있다.
 * 이런 경우에 Debounce를 사용하면 설정한 시간만큼 대기 후 Ajax 요청을 보내도록 구현할 수 있다.
 *
 * 사용 예:
 *      const func = async function() {
 *          await axios.get('/getItems');
 *      }
 *
 *      Debounce debounce = new Debounce();
 *      debounce.delay(func, 1000);
 *
 * 입력 행위와 같은 이벤트가 계속 발생할 때 debouce.delay() 호출하면 기존 요청된 것은 초기화되며
 * 다시 1000ms 만큼 대기 후 func을 호출한다.
 */
class Debounce {
    constructor() {
        this.timer = null;
    }

    delay(func, wait) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            func();
        }, wait);
    }
}

export default Debounce;


